import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertsService } from '../../services/alerts/alerts.service';
import { AlertStateEnum } from '../../enums/alert-state.enum';
import { AlertTypeEnum } from '../../enums/alert-type.enum';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * KYC Guard
 * Blocks access if: KYC is in review, nafath is not passed, or proxy requires action/is in review.
 */
export const kycGuard: CanActivateFn = (): boolean => {
  const alertsService = inject(AlertsService);
  const router = inject(Router);

  const redirectToHome = (): boolean => {
    router.navigate([ROUTE_PATHS.HOME], {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
    return false;
  };

  const kycState = alertsService.getGate(AlertTypeEnum.COMPLETE_KYC)?.state;
  const nafathGate = alertsService.getGate(AlertTypeEnum.COMPLETE_NAFATH);
  const proxyState = alertsService.getGate(AlertTypeEnum.MINOR_PROXY)?.state;

  const shouldBlock =
    kycState === AlertStateEnum.IN_REVIEW ||
    (!!nafathGate && nafathGate.state !== AlertStateEnum.PASSED) ||
    proxyState === AlertStateEnum.ACTION_REQUIRED ||
    proxyState === AlertStateEnum.IN_REVIEW;

  return shouldBlock ? redirectToHome() : true;
};
